import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import logo from '../../assets/SenritsuXwordmarkwhite.png';
import '../../styles/Auth.css';

export default function EmailConfirmationPage() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const location = useLocation();
  const email = location.state?.email || '';
  const { resendConfirmation } = useAuth();

  const handleResend = async () => {
    if (!email) {
      setError('No email address available. Please sign up again.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      await resendConfirmation(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Failed to resend. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 480, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <img src={logo} alt="SenritsuX" className="auth-brand-logo" style={{ marginBottom: '1.5rem' }} />
        </div>

        <div className="email-confirm-icon">✉️</div>

        <h2 className="auth-heading">Check Your Email</h2>
        <p className="auth-subheading" style={{ marginBottom: '1rem' }}>
          We&apos;ve sent a verification email to{' '}
          {email ? <strong style={{ color: '#fff' }}>{email}</strong> : 'your email address'}.
        </p>
        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.88rem', lineHeight: 1.6, marginBottom: '2rem' }}>
          Click the link in the email to verify your account. Once verified, you can sign in and start using SenritsuX.
          If you don&apos;t see it, check your spam folder.
        </p>

        {error && (
          <div className="auth-global-error">
            <span>⚠</span>
            <span>{error}</span>
          </div>
        )}

        {success && (
          <div className="auth-global-success" style={{ marginBottom: '1rem' }}>
            <span>✓</span>
            <span>Confirmation email resent successfully!</span>
          </div>
        )}

        <button
          className="auth-btn-secondary"
          onClick={handleResend}
          disabled={loading}
          style={{ marginBottom: '1rem' }}
        >
          {loading ? <span className="auth-spinner auth-spinner-light" /> : 'Resend Confirmation Email'}
        </button>

        <div className="auth-footer-text">
          Already verified? <Link to="/login">Sign In</Link>
        </div>
      </div>
    </div>
  );
}
